export default __webpack_public_path__ + "static/media/rawlobster.de460a7a.PNG";